import React from 'react';

import { API_URLS } from '../../../../../helpers/api/API_URLS';
import { basicGET } from '../../../../../helpers/api/fetchParams';

class CatalogControls extends React.Component {
    forceRebuild() {
		console.log("rebuild for " + this.props.clientCode);
		document.getElementById("rebuild-status").innerHTML = "sheduling....";

		fetch(API_URLS.rebuildCatalogs+this.props.clientCode, basicGET(localStorage.getItem("token")))
		.then(response => {
			if (response.ok) {
				console.log(response);
				document.getElementById("rebuild-status").innerHTML = "rebuild sheduled....";
			} else {
				document.getElementById("rebuild-status").innerHTML = "rebuild failed....";
			}
		}).catch(error => console.log(error));
	}
    render() {
        const siteCode = this.props.siteCode;
        const clientCode = this.props.clientCode

        return(
            <React.Fragment>
                <div className="input-row">
                    <label>Download Catalog CSVs</label>
                    {(this.props.dataSource === "sfn") ? (
                        <div>
                            <a href={API_URLS.SFN+clientCode+"/"+siteCode} target="_blank" rel="noopener noreferrer">Product Data Endpoint</a>
                        </div>
                    ) : (
                        <div>
                            <a href={API_URLS.PRODUCTS+clientCode+"/"+siteCode} target="_blank" rel="noopener noreferrer">Product Data Endpoint</a>
                        </div>
                    )}
                </div>
                <div className="input-row">
                    <label>Edit Catalog Values</label>
                    {(this.props.dataSource === "sfn") ? (
                        <div>
                            <a href="https://prodmin.mm-api.agency/?instance=sfn" target="_blank" rel="noopener noreferrer">Prodmin</a>
                        </div>
                    ) : (
                        <div>
                            <a href="https://prodmin.mm-api.agency" target="_blank" rel="noopener noreferrer">Prodmin</a>
                        </div>
                    )}
                </div>
                <div className="input-row">
                    <label>Force Catalog Rebuild</label>
                    <div>
                        <button className="button" onClick={() => this.forceRebuild()}>Rebuild</button>
                        <span id="rebuild-status" style={{marginLeft: 10}}></span>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
export default CatalogControls;


// WEBPACK FOOTER //
// ./src/component_client/components/ClientProfile/ProfileComponents/Catalogs/CatalogControls.js